<template>
  <base-dialog width="560px" show-close :visible.sync="visible" class="line-dialog">
    <template v-slot:header>{{ lineOperationMap[operation] }}</template>
    <el-form ref="form" :model="lineInfo" label-width="100px" :rules="rules" label-position="left">
      <el-form-item label="辅助线名称" prop="name">
        <el-input v-model="lineInfo.name"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="kind">
        <normal-select
          :select-list="kindList"
          :selected-item.sync="lineInfo.kind"
          filterable
        ></normal-select>
      </el-form-item>
      <el-form-item label="数值" v-if="lineInfo.kind === 'fixed'" prop="number">
        <el-input v-model="lineInfo.number"></el-input>
      </el-form-item>
      <template v-else>
        <el-form-item label="指标" prop="fieldId">
          <normal-select
            :select-list="quotaList"
            :selected-item.sync="lineInfo.fieldId"
            filterable
          ></normal-select>
        </el-form-item>
        <el-form-item label="计算方式" prop="calc">
          <normal-select
            :select-list="calcList"
            :selected-item.sync="lineInfo.calc"
            filterable
          ></normal-select>
        </el-form-item>
      </template>
      <el-form-item label="颜色" prop="color">
        <el-color-picker v-model="lineInfo.color"></el-color-picker>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import {
  kindList,
  calcList,
  lineOperationMap
} from "@/views/Backend/Admin/Statistics/chartEdit/static"
import { randomString } from "@/utils/common"

export default {
  name: "line-dialog",
  components: { NormalSelect, BaseDialog, BaseButton },
  props: {
    operation: String,
    line: Object,
    quotas: Array
  },
  data() {
    return {
      lineOperationMap,
      kindList,
      calcList,
      visible: false,
      lineInfo: {},
      rules: {
        name: [{ required: true, message: "请输入辅助线名称", trigger: "blur" }],
        kind: [{ required: true, message: "请选择类型", trigger: "change" }],
        number: [{ required: true, message: "请输入数值", trigger: "blur" }],
        fieldId: [{ required: true, message: "请选择字段", trigger: "change" }],
        calc: [{ required: true, message: "请选择计算方式", trigger: "change" }]
      }
    }
  },
  computed: {
    quotaList() {
      return (
        this.quotas
          ?.filter(quota => !quota.hidden)
          .map(quota => ({ label: quota.name, value: quota.id })) || []
      )
    }
  },
  methods: {
    open() {
      this.lineInfo = this.line
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.$emit("submit", this.lineInfo)
        this.visible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.line-dialog {
  .el-select {
    width: 100%;
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
      color: unset;
    }
  }
}
</style>
